import { render, staticRenderFns } from "./scrap-card.vue?vue&type=template&id=68e27b84&scoped=true&"
import script from "./scrap-card.vue?vue&type=script&lang=js&"
export * from "./scrap-card.vue?vue&type=script&lang=js&"
import style0 from "./scrap-card.vue?vue&type=style&index=0&id=68e27b84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e27b84",
  null
  
)

export default component.exports